import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {ChangeTypeEnum} from "./GatewayPendingConfigPayloadDTO";

// Same shape as the BE GetGatewaysCB.O.GatewayDTO: only name can come from the pending-config
// draft (when the item status is UPDATED), the other fields are the official ones.
class GatewayDTO {
  id!: number;
  name!: string;
  macAddress?: string;
  online!: boolean;
  status!: string;
  hasPendingDevice!: boolean;
  hasPendingGatewayFields!: boolean;
}

class GatewayPayloadItemDTO {
  gateway!: GatewayDTO;

  // UPDATED if the returned gateway fields come from the draft, CREATED if they were
  // rebuilt from the official row (never DELETED for the gateway itself).
  status!: ChangeTypeEnum;
}

/**
 * O Inner Class
 */
class O {
  gateways!: GatewayPayloadItemDTO[];
}

/**
 * I Inner Class
 */
class I {
  partitionId!: number;
}

export class GetGatewaysPayloadCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayPendingConfigOPEEnum.GetGatewaysPayload);
    this.i = new I();
    this.o = new O();
  }
}
